module.exports = __webpack_public_path__ + "img/valley.be5030ca.webp";